import React from 'react'
import WithTitle from '../../../hoc/WithTitle'

const DevicesPage = () => {
    return (
        <div>
            
        </div>
    )
}

export default WithTitle({component: DevicesPage, title: 'manage devices'})
